<template>
  <div>
    <v-radio-group class="ml-16" :name="name_property" v-model="datas.saveValue" color="info" :rules="[v => !!v || '*必須項目']" required>
      <div v-for="(data, index) in datas.value" :key="index" class="ele-radiobox">
        <v-radio
          :label="data"
          :value="data"
          :name="name_property"
          @click="radioBoxFunc"
        ></v-radio>
        <v-text-field
          class="text-field"
          v-show="displayFlg"
          label="その他の場合は入力してください"
          :name="name_property_other"
          :disabled="enableFlg"
          v-model="datas.saveValueOther"
          required
        ></v-text-field>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'RadioBox',
  components: {
  },
  data () {
    return {
      enableFlg: true
    }
  },
  props: {
    datas: {
      type: Object,
      required: true
    },
    name_property: {
      type: String,
      required: true
    },
    name_property_other: {
      type: String
    },
    displayFlg: {
      type: Boolean
    }
  },
  methods: {
    radioBoxFunc: function () {
      if (this.datas.saveValue.includes('その他:')) {
        this.enableFlg = false
      } else {
        this.enableFlg = true
      }
    }
  }
}
</script>
